import React from 'react'
import { type StepProps } from '@adsk/napi-shared'
import { HeaderComponent, BodyComponent, FooterComponent } from './components'
import {
	OnboardingUserAppContextType,
	useOnboardingUserContext,
} from '../../store'

const ProfileReadOnlyComponent = (): StepProps => {
	const {
		state: { profileReadOnlyMode },
	} = useOnboardingUserContext() as OnboardingUserAppContextType

	return {
		size: profileReadOnlyMode ? 'medium' : 'large',
		root: {
			props: {
				height: 'auto',
			},
		},
		header: {
			props: {
				disableBorder: false,
				style: {
					padding: '0px auto',
				},
			},
			content: <HeaderComponent />,
		},
		body: {
			content: <BodyComponent />,
			props: {},
		},
		footer: {
			content: <FooterComponent />,
			props: {
				// Disable border when in read only mode
				disableBorder: profileReadOnlyMode,
				style: {
					padding: '0px auto',
				},
			},
		},
	}
}

export default ProfileReadOnlyComponent
